import * as componentActions from '@catdetails/actions/pn';
import {ActionItemState} from '@catdetails/types';
import {Action} from '@ngrx/store';

export const initialState: ActionItemState = {
  isActive: false,
};

export function reducer(state: ActionItemState = initialState, action: Action) {

  let returnable = state;

  switch (action.type) {
    case componentActions.PROJECT_DETAILS_PN_ACTIVATE:
      returnable = {...state, isActive: true};
      break;
    case componentActions.PROJECT_DETAILS_PN_DEACTIVATE:
      returnable = {...state, isActive: false};
      break;
  }

  return returnable;
}



// WEBPACK FOOTER //
// /agent/workspace/CUS-LHT_NICE_nto_nto_CAT_develop@2/app/Resources/Public/src/app/modules/project-details/reducers/pn.reducer.ts